"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("../core/Observable");
exports.EMPTY = new Observable_1.Observable(function (observer) { return observer.complete(); });
exports.empty = function () { return exports.EMPTY; };
//# sourceMappingURL=empty.js.map